import { defineAsyncComponent } from 'vue'
export default {
  "landing-page": defineAsyncComponent(() => import("/usr/src/apps/finq-finance/src/layouts/landing.page.vue")),
  blank: defineAsyncComponent(() => import("/usr/src/apps/base/src/layouts/blank.vue")),
  default: defineAsyncComponent(() => import("/usr/src/apps/base/src/layouts/default.vue"))
}